import { send } from '@fiverr-private/futile';
import * as bq from './events/bigQueryEvents';
import { createBqWorkspacePageViewParams, createLandingPageViewParams } from './events/bigQueryEventsData';

class BIEvents {
    initialize(reportingData) {
        this.reportingData = { ...reportingData };
    }

    updateReportingData(data = {}) {
        this.reportingData = { ...this.reportingData, ...data };
    }

    mixpanelPageView({ pageName, source }){
        if (typeof MixpanelWrapper === 'undefined') {
            return;
        }

        MixpanelWrapper.trackPageView(pageName, {
            'Source Component': source
        });
    }

    sendBigQueryPageViewEvent(pageName, params = {}) {
        if (!this.reportingData) {
            return;
        }

        const eventData = createLandingPageViewParams({ ...this.reportingData, pageName, ...params });
        const { userId } = this.reportingData;

        if (userId) {
            eventData.user = [{ id: userId }];
        }

        send.sendEvents(eventData);
    }

    sendBigQueryEvent({ eventName, params = {} }) {
        if (!this.reportingData) {
            return;
        }

        const eventData = eventName === bq.WORKSPACE_LANDING_PAGE_SHOW ? createBqWorkspacePageViewParams({ ...this.reportingData, ...params }) : params;

        if (this.reportingData.userId) {
            eventData.user = [{ id: this.reportingData.userId }];
        }

        send.sendEvents(eventData);
    }
}

export default new BIEvents();
